import { render, staticRenderFns } from "./PSIOrder.vue?vue&type=template&id=6b34c3b0&scoped=true"
import script from "./PSIOrder.vue?vue&type=script&lang=js"
export * from "./PSIOrder.vue?vue&type=script&lang=js"
import style0 from "./PSIOrder.vue?vue&type=style&index=0&id=6b34c3b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b34c3b0",
  null
  
)

export default component.exports